/**
 * Значок «Избранного».
 *
 * Закладка вместо аватара: переписка с самим собой не должна выглядеть
 * как ещё один собеседник. В списке из десяти строк глаз находит её
 * по форме, не читая подпись.
 */
export function SavedIcon({ size = 48 }: { size?: number }) {
  return (
    <span className="saved-icon" style={{ width: size, height: size }} aria-hidden="true">
      <svg
        viewBox="0 0 24 24"
        width={Math.round(size * 0.5)}
        height={Math.round(size * 0.5)}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M6 4h12a1 1 0 0 1 1 1v15l-7-4.2L5 20V5a1 1 0 0 1 1-1z" />
      </svg>
    </span>
  )
}
